// extracted by mini-css-extract-plugin
export var contentBody = "_dc-9";
export var headerImage = "_dc-2";
export var imageButton = "_dc-7";
export var imageButtonIcon = "_dc-8";
export var imageHeader = "_dc-4";
export var imageHeaderText = "_dc-5";
export var imageOverlay = "_dc-3";
export var imageTitle = "_dc-6";
export var imageWrapper = "_dc-1";
export var taskList = "_dc-a";
export var widget = "_dc-0";